
const DD_MMM_YYYY = [/\d/, /\d/, ' ', /[A-Z]/, /[a-z]/, /[a-z]/, ' ', /\d/, /\d/, /\d/, /\d/];

const DD_MM_YYYY = [/\d/, /\d/, ' ', /\d/, /\d/, ' ', /\d/, /\d/, /\d/, /\d/];

export {
  DD_MMM_YYYY,
  DD_MM_YYYY,
};
